export enum DashboardClosedByMonthPivotMode {
    Committed = 'Committed',
    Number = 'Number',
}
